import React from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import InfoCard from '../../../../../components/common/InfoCard/InfoCard';
import AcceptanceNotificationCard from '../../../../../components/ui/AcceptanceNotificationCard/AcceptanceNotificationCard';

const HouseNotificationHistory = () => {
  const currentHouse = useSelector(
    (state) => state.housingStockStore.currentHouse
  );

  const { acceptanceCreateDate } = currentHouse || {};

  return Boolean(acceptanceCreateDate) ? (
    <InfoCard title="История оповещений">
      <Spin spinning={false}>
        <AcceptanceNotificationCard dateTime={acceptanceCreateDate} />
      </Spin>
    </InfoCard>
  ) : null;
};

export default HouseNotificationHistory;
